import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const PassengerRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--operations--passenger']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
